export default __webpack_public_path__ + "static/media/2-min.3591d9f2.jpg";